import { ldclient } from 'common/lib/ldclient';

import Interceptor from '../interceptor';
import * as ClassicApp from './classic';

function loadGamma() {
  return import(/* webpackChunkName: "gamma" */ 'gamma');
}

export function bootstrap(props) {
  return loadGamma().then((gamma) => {
    ClassicApp.removeElem();

    return gamma.bootstrap(props);
  });
}

export function mount(props) {
  return loadGamma().then((gamma) => {
    // decouple Trello classic styles from Gamma
    const coreStylesheet = document.querySelector(
      'link[rel="stylesheet"][href*="core"]',
    );
    if (coreStylesheet) {
      coreStylesheet.disabled = true;
    }

    ClassicApp.removeElem();
    $('#root').css({ display: 'block' });
    if (ldclient.variation('nachos.native_system_fonts', false)) {
      $('body').addClass('body-native-fonts');
    }

    Interceptor.setGamma(gamma);

    return gamma.mount(props);
  });
}

export function unmount() {
  return Promise.resolve();
}

export const timeouts = {
  bootstrap: { millis: 5000 },
  mount: { millis: 5000 },
  unmount: { millis: 5000 },
  unload: { millis: 5000 },
};



// WEBPACK FOOTER //
// ./app/scripts/singlespa/apps/gamma.js